export default {
  MSG_COM_W_0010: 'MSG-COM-W-0010',
  MSG_COM_W_0020: 'MSG-COM-W-0020',
  MSG_COM_W_0030: 'MSG-COM-W-0030',
  MSG_COM_W_0040: 'MSG-COM-W-0040',
  MSG_COM_W_0050: 'MSG-COM-W-0050',
  MSG_COM_W_0090: 'MSG-COM-W-0090',
  MSG_COM_W_0100: 'MSG-COM-W-0100',
  MSG_COM_W_0110: 'MSG-COM-W-0110',
  MSG_COM_W_0140: 'MSG-COM-W-0140',
  MSG_COM_W_0150: 'MSG-COM-W-0150',
  MSG_COM_W_0160: 'MSG-COM-W-0160',
  MSG_COM_W_0170: 'MSG-COM-W-0170',
  MSG_COM_W_0180: 'MSG-COM-W-0180',
  MSG_COM_W_0190: 'MSG-COM-W-0190',
  MSG_COM_W_0200: 'MSG-COM-W-0200',
  MSG_COM_W_0210: 'MSG-COM-W-0210',
  MSG_COM_W_0220: 'MSG-COM-W-0220',
  MSG_COM_W_0230: 'MSG-COM-W-0230',
  MSG_COM_W_0240: 'MSG-COM-W-0240',
  MSG_COM_W_0250: 'MSG-COM-W-0250',
  MSG_COM_W_0260: 'MSG-COM-W-0260',
  MSG_COM_W_0410: 'MSG-COM-W-0410',
  MSG_COM_W_0420: 'MSG-COM-W-0420',
  MSG_COM_W_0430: 'MSG-COM-W-0430',
  MSG_COM_W_0440: 'MSG-COM-W-0440',
  MSG_COM_Q_0010: 'MSG-COM-Q-0010',
  MSG_COM_Q_0020: 'MSG-COM-Q-0020',
  MSG_COM_Q_0030: 'MSG-COM-Q-0030',
  MSG_COM_Q_0040: 'MSG-COM-Q-0040',
  MSG_COM_E_0010: 'MSG-COM-E-0010',
  MSG_COM_E_0020: 'MSG-COM-E-0020',
  MSG_DCV_I_0010: 'MSG-DCV-I-0010',
  MSG_DCV_I_0020: 'MSG-DCV-I-0020',
  MSG_DCV_I_0030: 'MSG-DCV-I-0030',
  MSG_DCV_I_0040: 'MSG-DCV-I-0040',
  MSG_DCV_W_0200: 'MSG-DCV-W-0200',
  MSG_DCV_W_0210: 'MSG-DCV-W-0210',
  MSG_DCV_W_0220: 'MSG-DCV-W-0220',
  MSG_DCV_W_0230: 'MSG-DCV-W-0230',
  MSG_DCV_W_0240: 'MSG-DCV-W-0240',
  MSG_DCV_W_0260: 'MSG-DCV-W-0260',
  MSG_DCV_W_0270: 'MSG-DCV-W-0270',
  MSG_DCV_W_0280: 'MSG-DCV-W-0280',
  MSG_DCV_W_0290: 'MSG-DCV-W-0290',
  MSG_DCV_W_0300: 'MSG-DCV-W-0300',
  MSG_DCV_W_0310: 'MSG-DCV-W-0310',
  MSG_DCV_W_0320: 'MSG-DCV-W-0320',
  MSG_DCV_W_0330: 'MSG-DCV-W-0330',
  MSG_DCV_W_0340: 'MSG-DCV-W-0340',
  MSG_DCV_W_0350: 'MSG-DCV-W-0350',
  MSG_DCV_W_0360: 'MSG-DCV-W-0360',
  MSG_DCV_W_0370: 'MSG-DCV-W-0370',
  MSG_DCV_W_0380: 'MSG-DCV-W-0380',
  MSG_DCV_W_0400: 'MSG-DCV-W-0400',
  MSG_DCV_W_0410: 'MSG-DCV-W-0410',
  MSG_DCV_W_0420: 'MSG-DCV-W-0420',
  MSG_DCV_W_0430: 'MSG-DCV-W-0430',
  MSG_DCV_W_0440: 'MSG-DCV-W-0440',
  MSG_DCV_W_0450: 'MSG-DCV-W-0450',
  MSG_DCV_W_0460: 'MSG-DCV-W-0460',
  MSG_DCV_W_0470: 'MSG-DCV-W-0470',
  MSG_DCV_W_0480: 'MSG-DCV-W-0480',
  MSG_DCV_W_0510: 'MSG-DCV-W-0510',
  MSG_DCV_W_0520: 'MSG-DCV-W-0520',
  MSG_DCV_W_0530: 'MSG-DCV-W-0530',
  MSG_DCV_W_0540: 'MSG-DCV-W-0540',
  MSG_DCV_W_0550: 'MSG-DCV-W-0550',
  MSG_DCV_W_0560: 'MSG-DCV-W-0560',
  MSG_DCV_W_0570: 'MSG-DCV-W-0570',
  MSG_DCV_W_0580: 'MSG-DCV-W-0580',
  MSG_DCV_W_0590: 'MSG-DCV-W-0590',
  MSG_DCV_W_0600: 'MSG-DCV-W-0600',
  MSG_DCV_W_0610: 'MSG-DCV-W-0610',
  MSG_DCV_W_0620: 'MSG-DCV-W-0620',
  MSG_DCV_W_0630: 'MSG-DCV-W-0630',
  MSG_DCV_W_0640: 'MSG-DCV-W-0640',
  MSG_DCV_W_0650: 'MSG-DCV-W-0650',
  MSG_DCV_W_0660: 'MSG-DCV-W-0660',
  MSG_DCV_W_0670: 'MSG-DCV-W-0670',
  MSG_DCV_Q_0010: 'MSG-DCV-Q-0010',
  MSG_DCV_Q_0020: 'MSG-DCV-Q-0020',
  MSG_DCV_Q_0030: 'MSG-DCV-Q-0030',
  MSG_DCV_Q_0040: 'MSG-DCV-Q-0040',
  MSG_DCV_Q_0050: 'MSG-DCV-Q-0050',
  MSG_DCV_Q_0060: 'MSG-DCV-Q-0060',
  MSG_DCV_Q_0070: 'MSG-DCV-Q-0070',
  MSG_DCV_Q_0080: 'MSG-DCV-Q-0080',
  MSG_DCV_Q_0090: 'MSG-DCV-Q-0090',
  MSG_INS_Q_0010: 'MSG-INS-Q-0010',
  MSG_INS_W_0010: 'MSG-INS-W-0010',
  MSG_INS_W_0020: 'MSG-INS-W-0020',
  MSG_SMP_Q_0010: 'MSG-SMP-Q-0010',
  MSG_SMP_Q_0020: 'MSG-SMP-Q-0020',
  MSG_SMP_W_0010: 'MSG-SMP-W-0010',
  MSG_SMP_W_0020: 'MSG-SMP-W-0020',
  MSG_SMP_W_0030: 'MSG-SMP-W-0030',
  MSG_SMP_W_0040: 'MSG-SMP-W-0040',
  MSG_ADM_W_0010: 'MSG-ADM-W-0010',
  MSG_ADM_W_0020: 'MSG-ADM-W-0020',
  MSG_ADM_W_0030: 'MSG-ADM-W-0030',
  MSG_ADM_W_0040: 'MSG-ADM-W-0040',
  MSG_ADM_W_0060: 'MSG-ADM-W-0060',
  MSG_ADM_W_0070: 'MSG-ADM-W-0070',
  MSG_ADM_W_0080: 'MSG-ADM-W-0080',
  MSG_ADM_W_0090: 'MSG-ADM-W-0090',
  MSG_ADM_W_0100: 'MSG-ADM-W-0100',
  MSG_ADM_W_0110: 'MSG-ADM-W-0110',
  MSG_ADM_W_0120: 'MSG-ADM-W-0120',
  MSG_ADM_W_0130: 'MSG-ADM-W-0130',
  MSG_ADM_W_0140: 'MSG-ADM-W-0140',
  MSG_ADM_Q_0010: 'MSG-ADM-Q-0010',
  MSG_ADM_Q_0020: 'MSG-ADM-Q-0020',
  MSG_PGM_I_0010: 'MSG-PGM-I-0010',
  MSG_PGM_I_0020: 'MSG-PGM-I-0020',
  MSG_PGM_Q_0010: 'MSG-PGM-Q-0010',
  MSG_PGM_Q_0020: 'MSG-PGM-Q-0020'
};
